export const WEBSOCKET_EMIT_DOUBLE = 'duplicate'

export const ROUTE_PATH_DOUBLE_CONNECTION = '/double-connection'
